import { render } from "./ITTerms.vue?vue&type=template&id=dd5d9042&scoped=true"
import script from "./ITTerms.vue?vue&type=script&lang=js"
export * from "./ITTerms.vue?vue&type=script&lang=js"

import "./ITTerms.vue?vue&type=style&index=0&id=dd5d9042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd5d9042"]])

export default __exports__